export const steps = [
  'Project Info',
  'Team',
  'Checklist',
  'Sub Project',
  'Documents',
  'Review & Launch',
];

export const stepsHeadings = [
  'Setup Your Project',
  'Define Your Team',
  'Select Checklist',
  'Create Sub Projects',
  'Upload Documents',
  'Final Review',
];

export const getInviteStatus: any = {
  JOINED: 'Joined',
  PENDING: 'Pending',
};

export const profileDropdown = [
  {
    name: 'menu_profile',
    icon: '',
  },
  {
    name: 'menu_plan_and_subscription',
  },
  {
    name: 'menu_language',
  },
  {
    name: 'menu_refer',
  },
  {
    name: 'menu_help',
  },
  {
    name: 'menu_logout',
  },
];

export const message: any = {
  saveStep: 'Saved',
};

export const userSearchOptions = [
  { label: 'Project', value: 'project' },
  { label: 'Joined', value: 'joined' },
  { label: 'Pending', value: 'pending' },
];

export const userRoles: any = {
  OWNER: 'OWNER',
  PROJECT_ADMIN: 'PROJECT ADMIN',
  INSPECTOR: 'INSPECTOR',
  DOER: 'DOER',
};

export const roles = [
  { label: 'Project admin', value: 'PROJECT ADMIN' },
  { label: 'Inspector', value: 'INSPECTOR' },
  { label: 'Doer', value: 'DOER' },
];

export const pagination = {
  page: 1,
  limit: 10,
};
